import styled from "styled-components";

export const PackWrapper = styled.div`
  display: flex;
  flex-direction: column;
  grid-row-gap: 8px;
  &.border-active {
    .item-wrapper{ 
      border: 2px solid #ECEFF1;
    }
}
.items-overlay{
  display: grid;
  grid-template-columns: 1fr 1fr;
  display: flex;
  justify-content: space-between  
}
  .item-wrapper{ 
    border: 2px solid #ECEFF1;
    background-color: #F5FBFF;
    border-radius: 6px;
    padding: 5px 12px;
    grid-gap: 16px 16px;
    display: flex;
    flex-direction: column;
    grid-row-gap: 12px;
    cursor: pointer;
    &.active{
    border: 2px solid #1565D8;
    .items{
    }
    .items {
}
      }
    }
    .items {
    display: flex;
    flex-direction: column;
    p {
    margin: 0px;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0%;
    color: #808183;
    &:not(:first-child){
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0%;
    color: #4E5969;

    }
}
}
`;
